<template>
  <div class="home">
    <advertising></advertising>
    <header-page></header-page>
    <button
      v-show="isShowBackTop"
      @click="backToTop"
      class="backtop"
      >
    </button>
    <div class="grey">
      <!-- 最新政策 -->
      <div class="box01 wrap white">
        <div class="box01_l">
          <el-carousel height="259px" :autoplay="false">
            <el-carousel-item v-for="(item, index) in box01LData" :key="index">
              <a :href="item.link" target="_blank"><img :src="baseUrl + item.cover" alt=""></a>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="box01_r">
          <a :href="box01RData.moreLink" target="_blank" class="more">了解更多</a>
          <ul>
            <li :class="box01Active == 0 ? 'active xwzx_tips' : 'xwzx_tips'"
              @click="getBox01RList('170ba4d0-4c68-4425-8f5d-16b0b46e33f5', 0)">最新动态</li>
            <li :class="box01Active == 1 ? 'active zxzc_tips' : 'zxzc_tips'"
              @click="getBox01RList('9df029c2-b088-4585-9e2a-9aa049094545', 1)">最新政策</li>
            
          </ul>
          <div class="box01_list">
            <div v-for="(item, index) in box01RData.columnData" :key="index">
              <a :href="item.链接" :title="item.中文标题 || item.题名" target="_blank">{{ item.中文标题 || item.题名 }}</a>
              <span>{{ item.发表时间 }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 政策法规 -->
      <div class="box02 wrap white">
        <div class="box02_title">
          <div class="box02_title_l">
            <div :class="box02Active == 0 ? 'active' : ''"
              @click="getBox02List('34cfdde5-cfe0-46f5-a918-ec5fce3e27b9', 0)">政策法规</div>
            <div :class="box02Active == 1 ? 'active tip2' : 'tip2'"
              @click="getBox02List('0c26f268-6526-410e-91f5-3d475858677e', 1)">政策解读</div>
            <div :class="box02Active == 2 ? 'active tip2' : 'tip2'"
              @click="getBox02List('df586558-fe0f-45be-9c24-e9e1eac1197a', 2)">领导讲话</div>
          </div>
          <div style="width: 620px;">
            <div class="box02_title_c box02_title_c4" v-if="box02Active == 0">
              <swiper class="swiper4" ref="swiper4" :options="swiperOption4" style="height:32px;width:578px;" v-if="box02Clist">
                    <swiper-slide v-for="(item, index) in box02Clist" :key="index" style="width: auto;">
                      <div @click="getBox02(item.uid, index)"
                :class="box02CActive == index ? 'active box02_title_c_item box02_title_c_item1' : 'box02_title_c_item box02_title_c_item1'">{{ item.title }}</div>
                    </swiper-slide>
                  </swiper>
                  <div class="swiper-button-prev" slot="button-prev"></div>
                  <div class="swiper-button-next" slot="button-next"></div>
            </div>
          </div>
          <div class="box02_title_r">
            <a :href="box02Data.moreLink" class="more" target="_blank" v-if="!(box02Active == 0 && box02CActive ==-1)">了解更多</a>
          </div>
        </div>
        <div class="box02_content">
          <el-carousel :autoplay="false" height="220px"  arrow="always" v-if="box02Active == 0 && box02CActive ==-1">
            <el-carousel-item class="el_car_item" v-for="(list, index) in box02Data.columnData" :key="index">
              <li v-for="(item, index2) in list" :key="index2" class="xgww">
                <a :href="item.link" target="_blank">
                  <div>
                  <h3 :title="item.title">{{ item.title }}</h3>
                  <p>{{ item.publishtime.slice(0, 10) }}</p>
                </div>
                </a>
              </li>
            </el-carousel-item>
          </el-carousel>
          <!-- <el-carousel :autoplay="false" height="220px"  arrow="never" v-else>
            <el-carousel-item class="el_car_item el_car_item2" v-for="(list, index) in box02Data.columnData" :key="index">
              <div class="box02_item" v-for="(item, index2) in list" :key="index2">
                <a :href="item.链接" target="_blank" :title="item.题名 || item.篇名">{{ item.题名 || item.篇名 }}</a>
                <span>{{ item.发表时间 }}</span>
              </div>
            </el-carousel-item>
          </el-carousel> -->
          <div v-else style="height: 220px;">
            <div class="el_car_item el_car_item2" v-for="(list, index) in box02Data.columnData" :key="index">
              <div class="box02_item" v-for="(item, index2) in list" :key="index2">
                <a :href="item.链接" target="_blank" :title="item.题名 || item.篇名">{{ item.题名 || item.篇名 }}</a>
                <span>{{ item.发表时间.slice(0, 10) }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 县级农业科技网络书屋，以科技创新驱动农业农村现代化 -->
      <div class="box03">
        <h3 class="common_title">县级农业科技网络书屋，以科技创新驱动农业农村现代化</h3>
        <div class="wrap">
          <map-china></map-china>
        </div>
      </div>

      <!-- 农业产业知识大数据服务，助推农业产业高质量发展 -->
      <div class="box04">
        <h3 class="common_title">农业产业知识大数据服务，助推农业产业高质量发展</h3>
        <div class="wrap">
          <!-- <a :href="box04List.moreLink" class="more" target="_blank">了解更多</a> -->
          <!-- <ul class="box04_tab">
            <li :class="box04Active == 0 ? 'active' : ''"
              @click="changeCarousel(0)">
              农业产业</li>
            <li :class="box04Active == 1 ? 'active' : ''"
              @click="changeCarousel(1)">
              食品产业</li>
          </ul> -->
          <div class="box04_list">
            <el-carousel :autoplay="false" height="340px" :arrow="box04List.columnData.length>1?'always':'never'" ref="box04_carousel" indicator-position="none">
              <el-carousel-item class="box04_car_item" v-for="(list, index) in box04List.columnData" :key="index">
                <li v-for="(item, index2) in list" :key="index2">
                  <a :href="item.link" target="_blank" :class="'scale' + index2"><img :src="baseUrl + item.cover" alt="">
                    <p>{{ item.title }}</p>
                  </a>
                </li>
              </el-carousel-item>
            </el-carousel>
            <!-- <swiper :options="swiperOption" height="378px" ref="mySwiper"  class="swiper">
              <swiper-slide v-for="(item, index) in box04List.columnData" :key="index" class="box04_car_item">
                  <a :href="item.link" target="_blank"><img :src="baseUrl + item.cover" alt="">
                    <p>{{ item.title }}</p>
                  </a>
              </swiper-slide>
              <div class="swiper-button-prev" slot="button-prev"></div>
    <div class="swiper-button-next" slot="button-next"></div>
            </swiper> -->
          </div>
        </div>
      </div>

      <!-- 热门专题 -->
      <div class="box05">
        <h3 class="common_title">构建科学的课程体系，服务高素质农民培育</h3>
        <div class="wrap">
          <a :href="box05List.moreLink" class="more" target="_blank">了解更多</a>
          <h4 class="level_title">热门专题</h4>
          <div class="box05_list">
            <a :href="item.link" v-for="(item, index) in box05List.columnData" :key="index" target="_blank">
              <img :src="baseUrl + item.cover" alt="">
              <div>
                <p :title="item.title">{{ item.title }}</p><span>{{ item.createTime.slice(0, 10) }}</span>
              </div>
            </a>
          </div>
        </div>
      </div>

      <!-- 最新直播 -->
      <div class="box06">
        <div class="wrap">
          <a :href="box06List.moreLink" class="more" target="_blank">了解更多</a>
          <div class="box02_title_l">
            <div :class="box06Active == 0 ? 'active' : ''"
              @click="getBox06List('72d88b80-9810-4d89-b138-868cfbbcfb59', 0)">最新直播</div>
            <div :class="box06Active == 1 ? 'active tip2' : 'tip2'"
              @click="getBox06List('12be5139-a556-4c22-871a-f5d908291dd1', 1)">最新网校</div>
            <div :class="box06Active == 2 ? 'active tip2' : 'tip2'"
              @click="getBox06List('474690e3-18c2-46b6-9deb-4c8a98f3bb0b', 2)">热门课程</div>
          </div>
          <div class="box06_list">
            <a :href="item.link" v-for="(item, index) in box06List.columnData" :key="index" target="_blank">
              <img :src="baseUrl + item.cover" alt="">
              <div>
                <p :title="item.title">{{ item.title }}</p><span>{{ item.createTime.slice(0, 10) }}</span>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>

    <!-- 规划农业农村现代化建设，全面推进乡村振兴 -->
    <div class="box07 white">
      <h3 class="common_title">规划农业农村现代化建设，全面推进乡村振兴</h3>
      <div class="wrap">
        <ul class="box04_tab box07_tab01">
          <li v-for="(item, index) in box07Tab" :key="index" @click="box07TabClick(index)"
            :class="box07Active == index ? 'active' : ''">
            {{ item.title }}</li>
        </ul>
        <div class="box07_continer">
          <div class="box07_l">
            <a class="box07_img" target="_blank" :href="box07LImg.link">
              <img :src="baseUrl + box07LImg.cover" alt="">
            </a>
            <div class="box07_l_list">
              <el-carousel :autoplay="false" height="65px" arrow="always" indicator-position="none" class="box07_car">
                <el-carousel-item class="box07_car_item" v-for="(list, index) in box07LList.columnData" :key="index">
                  <li v-for="(item, index2) in list" :key="index2" :class="box07LImg.cover == item.cover ? 'active' : ''"
                    @click="handleImg(item)">
                    <img :src="baseUrl + item.cover" alt="">
                  </li>
                </el-carousel-item>
              </el-carousel>
            </div>
          </div>
          <div class="box07_r">
            <div class="box07_r_l">
              <swiper class="swiper2 box07_car_r" ref="swiper2" :options="swiperOption2" style="height:335px;">
                <swiper-slide v-for="(item, index) in box07Tab02" :key="index">
                  <li :class="box07Active02 == item.title ? 'active' : ''"
                    @click="box07Tab02Click(item.title)">
                    <p>{{ item.title }}</p>
                  </li>
                </swiper-slide>
              </swiper>
              <!-- <div class="swiper-button-prev" slot="button-prev"></div>
              <div class="swiper-button-next" slot="button-next"></div> -->
            </div>
            <div class="box07_r_r">
              <div class="box02_title_c box02_title_c3">
                  <swiper class="swiper3" ref="mySwiper" :options="swiperOption3" style="height:32px;" v-if="box07Tab03">
                    <swiper-slide  v-for="(item, index) in box07Tab03" :key="index" style="width: auto;">
                      <div @click="box07Tab03Click(item.code, index)" :class="box07Active03 == index ? 'active box02_title_c_item' : 'box02_title_c_item'">{{ item.title }}</div>
                    </swiper-slide>
                  </swiper>
                  <div class="swiper-button-prev" slot="button-prev"></div>
                  <div class="swiper-button-next" slot="button-next"></div>
              </div>
              <div class="box07_r_r_list">
                <div class="box07_r_r_item" v-for="(item, index) in box07Data.items" :key="index">
                  <a :href="item.href" target="_blank" :title="item.title">{{ item.title }}</a>
                  <!-- <span>{{ item.发表时间.slice(0, 10) }}</span> -->
                </div>
              </div>
              <div class="box07_more">
                <a :href="box07Data.moreUrl" target="_blank" class="more">了解更多</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="grey box08_grey">
      <!-- 和美乡村 -->
      <div class="box08 wrap">
        <h3 class="common_title">和美乡村</h3>
        <div class="box08_list">
          <div class="box08_item">
            <div class="box08_item_title">
              <h3>典型案例</h3>
              <a :href="currentUrl+'/xczx/home-case.html'" target="_blank" class="more">了解更多</a>
            </div>
            <div v-for="(item, index) in box08LList.columnData" :key="index" class="box08_item_text">
              <a :href="item.链接" :title="item.篇名" target="_blank">{{ item.篇名 }}</a>
              <span>{{ item.发表时间.slice(0, 10) }}</span>
            </div>
          </div>
          <div class="box08_item">
            <div class="box08_item_title">
              <h3>国外经验</h3>
              <a :href="currentUrl+'/xczx/experience.html'" target="_blank" class="more">了解更多</a>
            </div>
            <div v-for="(item, index) in box08RList.columnData" :key="index" class="box08_item_text">
              <a :href="item.链接" :title="item.篇名" target="_blank">{{ item.篇名 }}</a>
              <span>{{ item.发表时间.slice(0, 10) }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <footer-page></footer-page>
  </div>
</template>

<script>
import Advertising from '@/components/Advertising.vue'
import HeaderPage from '@/components/Header.vue'
import FooterPage from '@/components/Footer.vue'
import MapChina from './component/MapChina.vue'
import { getUrmData, getXbData, urlApi } from '@/assets/js/api'
import { box07Tab } from '@/utils/mapData'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
// import 'swiper/dist/css/swiper.css'
import 'swiper/swiper.css'

export default {
  name: 'indexPage',
  components: {
    HeaderPage, Advertising, MapChina, FooterPage, swiper, swiperSlide
  },
  data () {
    return {
      swiperOption: {
        // 可见图片张数
        slidesPerView: 3,
        spaceBetween: 15,
        // 无限循环
        loop: true,
        // 自动轮播
        autoplay: {
          delay: 5000,
          stopOnLastSlide: false
        },
        // 上下按钮点击轮播效果
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        centeredSlides: true
      },
      swiperOption2: {
        slidesPerView: 6,
        direction: 'vertical',
        on: {
          click: (e) => {
            console.log('111111111111111')
          }
        }
        // navigation: {
        //   nextEl: '.box07_r_l .swiper-button-next',
        //   prevEl: '.box07_r_l .swiper-button-prev'
        // }
      },
      swiperOption3: {
        initialSlide: 0,
        slidesPerView: 'auto',
        spaceBetween: 6,
        navigation: {
          nextEl: '.box02_title_c3 .swiper-button-next',
          prevEl: '.box02_title_c3 .swiper-button-prev'
        }
      },
      swiperOption4: {
        slidesPerView: 'auto',
        spaceBetween: 10,
        navigation: {
          nextEl: '.box02_title_c4 .swiper-button-next',
          prevEl: '.box02_title_c4 .swiper-button-prev'
        }
      },
      box01LData: [],
      adList: [],
      box01RData: [],
      box01Active: 0,
      baseUrl: `${urlApi}/urm-api/`,
      box02Active: 0,
      box02CActive: -1,
      box02Clist: [
        { title: '产业政策', uid: 'd49dec25-93ec-402f-9458-7551b892a3f5' },
        { title: '人才政策', uid: '03161906-4d72-40a0-9eda-500a7c0848f3' },
        { title: '文化政策', uid: '946385ce-9356-448a-b089-e58ac13e5143' },
        { title: '生态政策', uid: '9449cec2-b26b-4feb-8170-578ef0e6c25b' },
        { title: '土地政策', uid: 'f1a8af18-54b7-4872-9f91-e86ac1d34a38' },
        { title: '农业金融政策', uid: '5616f7c5-7905-4429-9360-68dc3d4f33cc' },
        { title: '农村建设政策', uid: '9eb31146-8d77-4faf-b3e7-2bae4e1fc4a1' },
        { title: '扶贫政策', uid: 'e9abf521-d2f9-4009-8d66-dd94489ff76d' }
      ],
      box02Data: [],
      box04Active: 0,
      box04List: [],
      box05List: [],
      box06Active: 0,
      box06List: [],
      box08LList: [],
      box08RList: [],
      box07Tab: box07Tab,
      box07Tab02: box07Tab[0].children,
      box07Tab03: box07Tab[0].children[0].children,
      box07Active: 0,
      box07Active02: box07Tab[0].children[0].title,
      box07Active03: 0,
      box07LImg: {},
      box07LList: [],
      box07Data: {},
      currentUrl: '',
      isShowBackTop: false,
    }
  },
  created () {
    // box01
    this.getBox01List('e7f7d117-9783-4453-81ec-5d06907d8d7a')
    this.getBox01RList('170ba4d0-4c68-4425-8f5d-16b0b46e33f5', 0)

    // box02
    this.getBox02List('34cfdde5-cfe0-46f5-a918-ec5fce3e27b9', 0)

    // box05
    this.getBox05List('95567f45-95e8-48f0-b9fe-ef644812d0ef')
    // box06
    this.getBox06List('72d88b80-9810-4d89-b138-868cfbbcfb59', 0)

    // box07
    this.getBox07LList('efedd708-18a6-483d-a0bd-0205044b1760')
    this.getBox07List('57270341-8eeb-4bed-8004-0cb6e0b65294')
    // box08
    this.getBox08List('3f527869-d501-4868-a829-b99d3028c64e', 0)
    this.getBox08List('8398dc5f-041f-483b-bbd3-4e0a3b764b52', 1)
    // box04
    this.getBox04List('9f9f5545-ee0a-4e05-99c0-904ae76a39a8', 0)
    this.currentUrl = window.location.origin
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    backToTop() {
      window.scrollTo({ top: 0, behavior: "smooth" }); // 平滑滚动到页面顶部
    },
    handleScroll() {
      const scrollPosition =
        document.documentElement.scrollTop || document.body.scrollTop;
      this.isShowBackTop = scrollPosition > 25; // 当滚动超过200px时显示返回顶部按钮
    },
    getBox01List (uid) {
      getUrmData({ uid: uid, getData: true }).then((res) => {
        if (res.code === 200) {
          this.box01LData = res.data.columnData
        }
      })
    },
    getBox01RList (uid, index) {
      this.box01Active = index
      this.box01RData = []
      getUrmData({ uid: uid, getData: true }).then((res) => {
        if (res.code === 200) {
          this.box01RData = res.data
        }
      })
    },
    getBox02 (uid, index) {
      this.box02CActive = index
      this.box02Data = []
      getUrmData({ uid: uid, getData: true }).then((res) => {
        if (res.code === 200) {
          this.box02Data = res.data
          let num = 6
          if (this.box02Active === 0 && this.box02CActive === -1) {
            num = 6
          } else {
            num = 10
          }
          // eslint-disable-next-line prefer-const
          let newDataList = []
          let current = 0
          if (this.box02Data.columnData && this.box02Data.columnData.length > 0) {
            for (let i = 0; i <= this.box02Data.columnData.length - 1; i++) {
              if (i % num !== 0 || i === 0) {
                if (!newDataList[current]) {
                  newDataList.push([this.box02Data.columnData[i]])
                } else {
                  newDataList[current].push(this.box02Data.columnData[i])
                }
              } else {
                current++
                newDataList.push([this.box02Data.columnData[i]])
              }
            }
          }
          this.box02Data.columnData = [...newDataList]
        }
      })
    },
    getBox02List (uid, index) {
      if (index === 0) {
        this.box02CActive = -1
      }
      this.box02Active = index
      this.box02Data = []
      getUrmData({ uid: uid, getData: true }).then((res) => {
        if (res.code === 200) {
          this.box02Data = res.data
          let num = 6
          if (this.box02Active === 0 && this.box02CActive === -1) {
            num = 6
          } else {
            num = 10
          }
          // eslint-disable-next-line prefer-const
          let newDataList = []
          let current = 0
          if (this.box02Data.columnData && this.box02Data.columnData.length > 0) {
            for (let i = 0; i <= this.box02Data.columnData.length - 1; i++) {
              if (i % num !== 0 || i === 0) {
                if (!newDataList[current]) {
                  newDataList.push([this.box02Data.columnData[i]])
                } else {
                  newDataList[current].push(this.box02Data.columnData[i])
                }
              } else {
                current++
                newDataList.push([this.box02Data.columnData[i]])
              }
            }
          }
          this.box02Data.columnData = [...newDataList]
        }
      })
    },
    changeCarousel (index) {
      if (index === 0) {
        this.getBox04List('9f9f5545-ee0a-4e05-99c0-904ae76a39a8', 0)
      } else {
        this.getBox04List('3021790b-561e-4c87-b1ff-480ab1869b7d', 1)
      }
      this.$refs.box04_carousel.setActiveItem(0)
    },
    getBox04List (uid, index) {
      this.box04Active = index
      this.box04List = []
      getUrmData({ uid: uid, getData: true }).then((res) => {
        if (res.code === 200) {
          this.box04List = res.data
          // eslint-disable-next-line prefer-const
          let newDataList = []
          let current = 0
          if (this.box04List.columnData && this.box04List.columnData.length > 0) {
            for (let i = 0; i <= this.box04List.columnData.length - 1; i++) {
              if (i % 5 !== 0 || i === 0) {
                if (!newDataList[current]) {
                  newDataList.push([this.box04List.columnData[i]])
                } else {
                  newDataList[current].push(this.box04List.columnData[i])
                }
              } else {
                current++
                newDataList.push([this.box04List.columnData[i]])
              }
            }
          }
          this.box04List.columnData = [...newDataList]
        }
      })
    },
    getBox05List (uid) {
      getUrmData({ uid: uid, getData: true }).then((res) => {
        if (res.code === 200) {
          this.box05List = res.data
        }
      })
    },
    getBox07LList (uid) {
      getUrmData({ uid: uid, getData: true }).then((res) => {
        if (res.code === 200) {
          this.box07LList = res.data
          // eslint-disable-next-line prefer-const
          let newDataList = []
          let current = 0
          if (this.box07LList.columnData && this.box07LList.columnData.length > 0) {
            for (let i = 0; i <= this.box07LList.columnData.length - 1; i++) {
              if (i % 4 !== 0 || i === 0) {
                if (!newDataList[current]) {
                  newDataList.push([this.box07LList.columnData[i]])
                } else {
                  newDataList[current].push(this.box07LList.columnData[i])
                }
              } else {
                current++
                newDataList.push([this.box07LList.columnData[i]])
              }
            }
          }
          this.box07LList.columnData = [...newDataList]
          this.box07LImg = this.box07LList.columnData[0][0]
        }
      })
    },
    handleImg (item) {
      this.box07LImg = item
    },
    getBox06List (uid, index) {
      this.box06Active = index
      this.box06List = []
      getUrmData({ uid: uid, getData: true }).then((res) => {
        if (res.code === 200) {
          this.box06List = res.data
        }
      })
    },
    getBox07List (code) {
      this.box07Data = {}
      getXbData({ code: code }).then((res) => {
        if (res.code === 200) {
          this.box07Data = res.data
        }
      })
    },
    getBox08List (uid, index) {
      getUrmData({ uid: uid, getData: true }).then((res) => {
        if (res.code === 200) {
          if (index === 0) {
            this.box08LList = res.data
          } else {
            this.box08RList = res.data
          }
        }
      })
    },
    // 多维数组转一维
    flatten (arr) {
      return arr.reduce(
        (acc, val) => acc.concat(Array.isArray(val) ? this.flatten(val) : val), [])
    },
    // box07点击第一层级
    box07TabClick (index) {
      this.box07Active = index
      box07Tab.forEach((item, i) => {
        if (index === i) {
          this.box07Tab02 = item.children
        }
      })
      console.log(this.box07Tab02)
      this.box07Active02 = this.box07Tab02[0].title
      this.box07Tab03 = this.box07Tab02[0].children
      this.getBox07List(this.box07Tab03[0].code)
      this.box07Active03 = 0
    },
    // box07点击第二层级
    box07Tab02Click (title) {
      this.box07Active02 = title
      this.flatten(this.box07Tab02).forEach((item, i) => {
        if (title === item.title) {
          this.box07Tab03 = item.children
        }
      })
      this.getBox07List(this.box07Tab03[0].code)
      this.box07Active03 = 0
    },
    box07Tab03Click (code, index) {
      this.box07Active03 = index
      this.getBox07List(code)
    }
  }
}
</script>
<style lang="less" scoped></style>
<style scoped>
.backtop{
  position: fixed;
  bottom: 10%;
  right: 24px;
  display: block;
  border: none;
  cursor: pointer;
  background: url(@/assets/images/backtop.png) no-repeat center center;
  width:32px;
  height: 32px;
  opacity: 0.5;
  transition: 0.5s;
}
.backtop:hover{
  opacity: 1;
}
.grey {
  background: rgb(244, 244, 244);
  padding: 32px 0;
}

.white {
  background: #FFFFFF;
}

.white.wrap {
  border-radius: 2px;
  padding: 56px 40px;
}

.box01 {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.box01_l {
  width: 400px;
  height: 259px;

}

/*
.box01_l .swiper-pagination-bullet {
  width: 8px;
  height: 8px;
  opacity: 0.3;

  background: #FFFFFF;
}

.box01_l .swiper-pagination-bullet-active {
  width: 20px;
  border-radius: 4px;
  opacity: 1;
  background: #FFFFFF;
} */

.box01_r {
  width: 772px;
  position: relative
}

.box01_r ul {
  display: flex;
  align-items: center;
  margin-bottom: 37px;
}

.box01_r ul li {
  color: #8C8C8C;
  font-size: 18px;
  font-weight: normal;
  margin-right: 53px;
  cursor: pointer;
  position: relative;
}

.zxzc_tips.active::after {
  content: '';
  position: absolute;
  width: 26px;
  top: 0;
  right: -25px;
  height: 14px;
  background: url(@/assets/images/new.png) no-repeat center center;
}
.box03 {
  padding-top: 24px;
  padding-bottom: 48px;
}

.xwzx_tips.active::after {
  content: '';
  position: absolute;
  width: 26px;
  top: 0;
  right: -25px;
  height: 14px;
  background: url(@/assets/images/hot.png) no-repeat center center;
}

.xwzx_tips::before {
  content: '';
  position: absolute;
  width: 1px;
  height: 18px;
  background: #E3E3E3;
  top: 8px;
  left: -26px;
}

.box01_r ul li.active {
  color: #222222;
  font-size: 24px;

}

.box01_r .more {
  position: absolute;
  top: -5px;
  right: 0;
}

.box01_list div {
  display: flex;
  justify-content: space-between;
  align-items: center;
  line-height: 23px;
  margin-top: 17px;
}
.box01_list div::before,
.box08_item_text::before,
.box07_r_r_item::before,
.box02_item::before {
  content: '';
  display: block;
  width: 9.8px;
  height: 10px;
  background: url(@/assets/images/leaf.png) no-repeat center center;
  background-size: 100% 100%;
  margin-right: 12px;
}

.box01_list div a {
  display: block;
  /* width: 660px; */
  flex: 1;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  color: #222222;
  font-size: 16px;
}

.box01_list div a:hover {
  color: #00A69B;
}

.box01_list div span {
  color: #8C8C8C;
  font-size: 16px;
  width: 94px;
  text-align: right;
  display: block;
}

.box02 {
  margin-top: 32px;
}

.el-carousel__item img {
  width: 100%;
  height: 100%;
}
</style>
<style>
.el-carousel__arrow {
  width: 48px;
  height: 48px;
  background: url(@/assets/images/arrow_l.png) no-repeat center center;
  background-size: 60% 60%;

}

.el-carousel__arrow i {
  display: none;
}

.el-carousel__arrow--right,
.el-notification.right {
  right: 0;
  background: url(@/assets/images/arrow_r.png) no-repeat center center;
  background-size: 60% 60%;
}

.el-carousel__arrow--left {
  left: 0;
}

.el-carousel__arrow:hover {
  background-color: transparent;
}
.box04 {
  height: 652px;
  background: url(@/assets/images/box04_bg.png) no-repeat center center;
  background-size: 100% 100%;
  padding-top: 64px;
}
.box04 .common_title{
  margin-top: 0;
}

.box04 .el-carousel__button {
  width: 8px;
  height: 8px;
  background: #E3E3E3;
  opacity: 1;
  border-radius: 50%;
}

.box04 .el-carousel__indicator.is-active button {
  width: 20px;
  height: 8px;
  border-radius: 4px;
  opacity: 1;

  background: #222222;
}

.box01_l .el-carousel__button {
  width: 8px;
  height: 8px;
  background: #fff;
  opacity: .3;
  border-radius: 50%;
}

.box01_l .el-carousel__indicator.is-active button {
  width: 20px;
  height: 8px;
  border-radius: 4px;
  opacity: 1;

  background: #fff;
}

.box02_content .el-carousel__indicators,
.box01_l .el-carousel__arrow {
  display: none;
}

.swiper-container-vertical>.swiper-wrapper {
    flex-direction: column;
}
.swiper-container {
    margin-left: auto;
    margin-right: auto;
    position: relative;
    overflow: hidden;
    list-style: none;
    padding: 0;
    z-index: 1;
}
</style>
